import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { BasePageComponent } from '../../../core/classes/base-page';
import { ReimburseService } from '../../../core/api/reimburse.service';
import { TagService } from '../../../core/api/tag.service';
import { ExpanseCategoryService } from '../../../core/api/expanse-category.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../core/services/auth.service';
import { HelpersService } from '../../../core/services/helpers.service';
import { LoadingService } from '../../../core/services/loading.service';
import { FileService } from '../../../core/api/file.service';
import { debounceTime } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FilePreviewComponent } from '../../../components/file-preview/file-preview.component';

@Component({
  selector: 'app-reimbursement-claimer',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    RouterModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './reimbursement-claimer.component.html',
  styleUrl: './reimbursement-claimer.component.scss',
})
export class ReimbursementClaimerComponent
  extends BasePageComponent<any>
  implements OnInit
{
  searchFormControl = new FormControl();
  counter: any = {
    all: 0,
    draft: 0,
    sent: 0,
    approved: 0,
    reimbursed: 0,
    rejected: 0,
  };
  currentFilter: any;
  constructor(
    public override helpers: HelpersService,
    public override router: Router,
    public override activatedRoute: ActivatedRoute,
    public override dialog: MatDialog,
    public override loading: LoadingService,
    public override service: ReimburseService,
    public override authService: AuthService,
    private fileService: FileService
  ) {
    super(
      helpers,
      router,
      activatedRoute,
      dialog,
      loading,
      service,
      authService
    );
    this.displayedColumns = [
      'no',
      'refId',
      'title',
      'file',
      'expanse_category',
      'status',
      'date',
      'amount',
      'action',
    ];
    this.sortActive = 'updated_at';
    this.sortDirection = 'desc';
    this.subject = 'refId';
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.loading.startLoading();
    this.service.getCountStatus().then(
      (res) => {
        if (res) {
          this.loading.endLoading();
          this.counter = res;
          this.counter.all = 0;
          Object.keys(this.counter).forEach((i: any) => {
            if (i != 'all') {
              this.counter.all += this.counter[i];
            }
          });
        } else {
          this.loading.endLoading();
        }
      },
      (error) => {
        this.helpers.sbError(error.message);
        this.loading.endLoading();
      }
    );

    this.searchFormControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((val: any) => {
        this.q.search = val;
        this.getData();
      });
  }

  addReimburse() {
    this.router.navigate(['/dashboard/reimbursement-claimer/action'], {
      queryParams: {
        m: 'add',
      },
    });
  }

  editReimburse(id: any) {
    this.router.navigate(['/dashboard/reimbursement-claimer/action'], {
      queryParams: {
        m: 'edit',
        id,
      },
    });
  }

  resubmit(id: any) {
    this.router.navigate(['/dashboard/reimbursement-claimer/resubmit'], {
      queryParams: {
        id,
      },
    });
  }

  detailReimburse(id: any) {
    this.router.navigate(['/dashboard/reimbursement-approval/action'], {
      queryParams: {
        m: 'detail',
        id,
      },
    });
  }

  download(item: any) {
    const targetFile = this.helpers.resolveTargetFile(item);
    if (targetFile?.id) {
      this.dialog
        .open(FilePreviewComponent, {
          width: '70vw',
          maxWidth: '70vw',
          maxHeight: '95vh',
          data: targetFile,
        })
        .afterClosed()
        .subscribe((item) => {
          if (item) {
          }
        });
    } else {
      this.helpers.sbError('Tidak ada file yang bisa diunduh');
    }
  }

  getFileItems(element: any): any[] {
    return this.helpers.normalizeFileItems(element);
  }

  changeFilter(filter: any): void {
    if (this.currentFilter === filter || filter == null) {
      this.currentFilter = null;
    } else {
      this.currentFilter = filter;
    }
    this.q.status = this.currentFilter;
    this.getData();
  }
}
